import type { NamedFieldProps } from "./Field.js";
import { StringSchema, getSource } from "shelving";
import { Field, useField } from "./Field.js";
import { FieldNotice } from "./FieldNotice.js";

export function TextAreaField({
	spellCheck = true,
	rows = 1,
	...props
}: {
	rows?: number;
	spellCheck?: boolean;
} & NamedFieldProps): React.ReactElement {
	const field = useField<string>(props);
	const { name, form, schema, fullplaceholder, value } = field;
	const onValue: React.ReactEventHandler<HTMLTextAreaElement> = ({ currentTarget }) => {
		form.publish(name, currentTarget.value);
		_resize(currentTarget, rows);
	};
	const { min } = getSource(StringSchema, schema);
	return (
		<Field {...field}>
			<textarea //
				name={name}
				ref={el => el && _resize(el, rows)}
				className="input space-none"
				placeholder={fullplaceholder}
				defaultValue={value}
				required={min > 0}
				spellCheck={spellCheck}
				rows={rows}
				onInput={onValue}
				onChange={onValue}
			/>
			<FieldNotice name={name} />
		</Field>
	);
}

function _resize(el: HTMLTextAreaElement, rows: number) {
	el.rows = rows;
	while (el.scrollHeight > el.clientHeight) el.rows++;
}
